module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_14.c928608b.png";